module.exports = __webpack_public_path__ + "static/flags/NE-a9549ea34139c32e137f3420a65c7d06.gif";